"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("./utils");
const v0 = (0, utils_1.buildTypes)({
    max: 9,
    types: {
        Address: "AccountId",
        LookupSource: "AccountId",
    }
});
exports.default = [v0];
